import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AuthWrapper from "./AuthWrapper";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";

// Re-export for compatibility in modules importing from index
export { store };

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <AuthWrapper />
      {/* <App /> */}
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
